import React, { useCallback } from 'react';

import { parseCSV } from '../../../helpers/csv.helper';
import { ccassService } from '../../../services';
import CCASSHistory, { CCASSHistoryProps } from './CCASSHistory';

const CCASSParticipationHistory: React.FC<
  Omit<CCASSHistoryProps, 'requestFn'> & {
    participantId: string;
    participantName: string;
  }
> = props => {
  const requestFn = useCallback(() => {
    return props.participantId === 'NOTINCCASS'
      ? ccassService
          .summaryHistory(undefined, `hk.${Number.parseInt(props.stockCode)}`)
          .then(historySummary => {
            return historySummary.map(item => {
              return {
                Date: item.Date,
                shareholding: item.issued_shares - item.total_ccass,
                issuedShares: item.issued_shares,
              };
            });
          })
      : ccassService
          .participantHistory(
            undefined,
            `hk.${Number.parseInt(props.stockCode)}`
          )
          .then(({ issuedSharesByDate, shareholding }) => {
            const allHistory = parseCSV<any>(shareholding);
            const participantIdentifier =
              props.participantId || props.participantName;
            return allHistory
              .map(item => ({
                Date: item.date,
                shareholding: item[participantIdentifier],
                issuedShares: issuedSharesByDate[item.date.toString()],
              }))
              .filter(({ shareholding }) => shareholding !== null);
          });
  }, [props.participantId, props.participantName, props.stockCode]);

  return <CCASSHistory {...props} requestFn={requestFn} />;
};

export default CCASSParticipationHistory;
